/** Linha de datas compartilhada pelos filtros de Tarefas e O.S.; mantém seleção e fuso no controlador. */
import { CalendarDays } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
interface DateFilterRowProps {
  /** Opcional quando o controlador já apresenta o título do período. */
  label?: string;
  fromDate: Date | undefined;
  toDate: Date | undefined;
  onFromChange: (date: Date | undefined) => void;
  onToChange: (date: Date | undefined) => void;
}

export function DateFilterRow({ label, fromDate, toDate, onFromChange, onToChange }: DateFilterRowProps) {
  return (
    <div className="space-y-1.5">
      {label && <Label className="text-xs flex items-center gap-1.5">
        <CalendarDays className="h-3 w-3" />
        {label}
      </Label>}
      <div className="flex gap-2">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" size="sm" className="h-7 flex-1 justify-start text-xs font-normal">
              {fromDate ? format(fromDate, 'dd/MM/yy') : 'De'}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start" side="bottom">
            <Calendar
              mode="single"
              selected={fromDate}
              onSelect={onFromChange}
              className="p-3 pointer-events-auto"
              locale={ptBR}
            />
          </PopoverContent>
        </Popover>
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" size="sm" className="h-7 flex-1 justify-start text-xs font-normal">
              {toDate ? format(toDate, 'dd/MM/yy') : 'Até'}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start" side="bottom">
            <Calendar
              mode="single"
              selected={toDate}
              onSelect={onToChange}
              className="p-3 pointer-events-auto"
              locale={ptBR}
            />
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
}

